import type { DaySchedule } from "../domain/types";

const weekday = (day: number): DaySchedule => ({
  day, opensAt: "08:30", morningUntil: "12:00", daytimeUntil: "17:00", closesAt: "22:00", daytimeScenario: "WEEKDAY_LUNCH",
});
const weekend = (day: number): DaySchedule => ({
  day, opensAt: "10:00", morningUntil: "12:00", daytimeUntil: "17:00", closesAt: "22:00", daytimeScenario: "WEEKEND_DAY",
});

export const scheduleConfig: DaySchedule[] = [weekday(1), weekday(2), weekday(3), weekday(4), weekday(5), weekend(6), weekend(7)];
